import React from "react";
import { Button, Tooltip, Tag, Table } from "antd";
import global from '../../../common/utility/global';

import CustomTable from "../../../components/CustomTable";
const BAJO = 'B';
const ALTO = 'A';
const OPTIMO = 'O';
export default function GeneralTable(props) {



  const renderColor = (row) => {
    if (row.estado.charAt(0) == BAJO)
      return 'red';
    if (row.estado.charAt(0) == ALTO)
      return '#52c41a';
    if (row.estado.charAt(0) == OPTIMO)
      return 'blue';
  };

  return (
    <Table
      className="table-resumen"
      dataSource={props.pagination.dataResumen}
      scroll={{ x: true }}
      size="small"
      style={{ overflowX: "auto" }}
      onChange={(pagination, filters, sorter) => {
        props.onChange({
          page: pagination.current,
          order: sorter.order,
          field: sorter.field
        })
      }}
      pagination={{
        total: props.pagination.total,
        current: props.pagination.page,
        pageSize: props.pagination.pageSize,
        showTotal: (total) => `${total} Registro(s) encontrado(s).`
      }}
      rowKey={(record) => record.uid}
      title={() => (
        <div style={{ width: "100%", textAlign: "right" }}>
          <div className="custom-options">
            {props.onExportExcel === undefined ? null : (
              <Button
                ghost
                type="success"
                icon="file-excel"
                onClick={props.onExportExcel}
                style={{ color: "#3fb703" }}
                loading={props.loadingExcel}
              >
                Excel
              </Button>
            )}
          </div>
        </div>
      )}
      columns={[
        {
          title: "Establecimiento",
          dataIndex: "nombreEstablecimiento",
          key: "nombreEstablecimiento",
          sorter: true,
        },
        {
          title: "Almacén",
          dataIndex: "nombreAlmacen",
          key: "nombreAlmacen",
          sorter: true,
        },
        {
          title: "Código de Referencia",
          dataIndex: "codigoReferencia",
          key: "codigoReferencia",
          sorter: true,
        },
        {
          title: "Producto",
          dataIndex: "nombre",
          key: "nombre",
          sorter: true,
        },
        {
          title: "Unidad de Medida",
          dataIndex: "nombreUnidadMedida",
          key: "nombreUnidadMedida",
          sorter: true,
        },
        {
          title: 'Marca',
          dataIndex: 'marca',
          key: 'marca',
          sorter: true
        },
        {
          title: 'Modelo',
          dataIndex: 'modelo',
          key: 'modelo',
          sorter: true
        },
        {
          title: 'Peso KG',
          dataIndex: 'peso',
          key: 'peso',
          sorter: true
        },
        {
          title: 'Categoria',
          dataIndex: 'categoria',
          key: 'categoria',
          sorter: true
        },
        {
          title: 'Lote',
          dataIndex: 'numeroLote',
          key: 'numeroLote',
          sorter: true
        },
        {
          title: 'Fecha Vencimiento',
          dataIndex: 'fechaVencimiento',
          key: 'fechaVencimiento',
          sorter: true
        },
        {
          title: 'Stock Min',
          dataIndex: 'stockMinimo',
          key: 'stockMinimo',
          sorter: true,
          align: 'right',
          render: (value) => (
            <span>{global.decimalFormat(value.toFixed(3))}</span>
          )
        },
        {
          title: 'Stock Max',
          dataIndex: 'stockMaximo',
          key: 'stockMaximo',
          sorter: true,
          align: 'right',
          render: (value) => (
            <span>{global.decimalFormat(value.toFixed(3))}</span>
          )
        },
        {
          title: "Stock Actual",
          dataIndex: "stockActual",
          key: "stockActual",
          sorter: true,
          align: 'right',
          render: (value) => (
            <span>{global.decimalFormat(value.toFixed(3))}</span>
          )
        },
        {
          title: "Stock Comprometido",
          dataIndex: "stockComprometido",
          key: "stockComprometido",
          sorter: true,
          align: 'right',
          render: (value) => (
            <span>{global.decimalFormat(value.toFixed(3))}</span>
          )
        },
        {
          title: "Stock Disponible",
          dataIndex: "stockDisponible",
          key: "stockDisponible",
          sorter: true,
          align: 'right',
          render: (value) => (
            <span>{global.decimalFormat(value.toFixed(3))}</span>
          )
        },
        {
          title: 'Estado',
          dataIndex: 'estado',
          key: 'estado',
          sorter: true,
          align: 'center',
          render: (value, row) => {
            return (<div className="custom-options" >
              <Tag color={renderColor(row)}>Stock {value}</Tag>
            </div>)
          }
        },
      ]}
    />
  );
}
